import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-git-insured',
  templateUrl: './git-insured.component.html',
  styleUrls: ['./git-insured.component.scss']
})
export class GitInsuredComponent {

  // producType: '0' = Conventional, '1' = Takaful (each shows Life + Non-Life)
  producType: string = null;
  searchTerm = '';
  products: any[] = [];

  constructor(private router: Router, route: ActivatedRoute) {
    try {
      this.products = JSON.parse(localStorage.getItem('currentUser')).product || [];
    } catch (e) {
      this.products = [];
    }
    route.params.subscribe((val: any) => {
      this.producType = val.producType;
      this.searchTerm = '';
    });
  }

  // --- view helpers (single source for green vs blue theme) ---
  get isTakaful(): boolean {
    return this.producType === '1';
  }

  get themeColor(): string {
    return this.isTakaful ? 'success' : 'primary';
  }

  get themeText(): string {
    return this.isTakaful ? 'green-text' : 'blue-text';
  }

  get title(): string {
    return this.isTakaful ? 'Takaful Products' : 'Conventional Products';
  }

  // icon based on product/menu name (keyword match, fallback = shield)
  productIcon(name: string): string {
    const n = (name || '').toLowerCase();
    if (n.includes('fire')) { return 'fire'; }
    if (n.includes('motor') || n.includes('car') || n.includes('auto') || n.includes('comprehensive')) { return 'car'; }
    if (n.includes('bond') || n.includes('surety')) { return 'file-contract'; }
    if (n.includes('group')) { return 'users'; }
    if (n.includes('health') || n.includes('medical')) { return 'heartbeat'; }
    if (n.includes('accident') || n.includes('personal')) { return 'user-shield'; }
    if (n.includes('life')) { return 'heart'; }
    if (n.includes('travel')) { return 'plane'; }
    if (n.includes('marine') || n.includes('cargo')) { return 'ship'; }
    if (n.includes('agri') || n.includes('crop')) { return 'leaf'; }
    if (n.includes('liability') || n.includes('cgl')) { return 'building'; }
    if (n.includes('takaful')) { return 'hands-helping'; }
    return 'shield-alt';
  }

  // --- one filter used by both sections ---
  private matches(d: any): boolean {
    const q = (this.searchTerm || '').trim().toLowerCase();
    if (!q) { return true; }
    if (!d) { return false; }
    return [d.varshortname, d.varlongname, d.description].join(' ').toLowerCase().includes(q);
  }

  // products of this page: takaful=yes for '1', else takaful!=yes, plus search
  private get pageProducts(): any[] {
    return this.products.filter(p => {
      const d = p.product_details;
      if (!d) { return false; }
      const isT = String(d.takaful || '').toLowerCase() === 'yes';
      if (!this.matches(d)) { return false; }
      return this.isTakaful ? isT : !isT;
    });
  }

  // --- fixed sections: Life / Non-Life from products + Group as fixed separate link ---
  get sections(): { heading: string, items: any[] }[] {
    const life = this.pageProducts.filter(p => p.product_details.classification == 1);
    const nonlife = this.pageProducts.filter(p => p.product_details.classification == 2);
    // fixed item: not from product list, goes to its own page
    const groupLink = { isGroupLink: true, varshortname: 'Group Products', varlongname: 'Customized group products.' };
    const q = (this.searchTerm || '').trim().toLowerCase();
    const groupMatch = !q || 'group products'.includes(q) || 'customized group'.includes(q);
    const list = [];
    if (life.length > 0) { list.push({ heading: 'LIFE PRODUCTS', items: life }); }
    if (nonlife.length > 0) { list.push({ heading: 'NON-LIFE PRODUCTS', items: nonlife }); }
    // group is conventional-only for now: hide on Takaful view ('1')
    if (groupMatch && !this.isTakaful) { list.push({ heading: 'GROUP PRODUCTS', items: [groupLink] }); }
    return list;
  }

  goGroup() {
    const base = (this.router.url || '').split('/')[1] || 'cac';
    this.router.navigateByUrl('/' + base + '/group-customized');
  }

  // variantid -> route (fallback = generic CAC-products page)
  navigate(p: any) {
    if (!p) { return; }
    const routes: { [id: number]: string } = {
      3: 'policy-issuance', 1: 'standard-fire', 2: 'comprehensive', 83: 'comprehensive-takaful',
      56: 'fire-issue', 60: 'fire-issue', 69: 'surity-bond', 70: 'surity-bond',
      76: 'surity-bond', 74: 'motorbanca', 75: 'cgl'
    };
    const seg = routes[p.variantid] || 'CAC-products';
    const base = (this.router.url || '').split('/')[1] || 'cac';
    const loginId = JSON.parse(localStorage.getItem('currentUser')).iloginId;
    const withId = (p.variantid == 3 || p.variantid == 1) ? '' : '/' + p.variantid;
    this.router.navigateByUrl('/' + base + '/' + seg + withId + '/quoteId/0/' + loginId);
  }

}

